'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const reactAriaComponents = require('react-aria-components');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const modalContentHeader = "_modal-content-header_6ku6s_1";
const styles = {
	modalContentHeader: modalContentHeader
};

const ModalContentHeader = ({ children, textAlign = "start" }) => {
  return React__default.default.createElement(reactAriaComponents.Heading, { className: styles.modalContentHeader, "data-text-align": textAlign, "data-zds": true, slot: "title" }, children);
};

exports.ModalContentHeader = ModalContentHeader;
//# sourceMappingURL=ContentHeader.cjs.js.map
